/**
 * 格网类 GridLayer
 */
import L from 'leaflet'
// 引入 leaflet.markercluster
import "leaflet.markercluster/dist/MarkerCluster.css"
import "leaflet.markercluster/dist/MarkerCluster.Default.css"
import "leaflet.markercluster";
export default L.Layer.extend({
    options: {
        layerId: null,
        geoJson: null
    },
    // 定义初始化方法
    initialize: function (options) {
        // console.log(this);
        // console.log(options);
        // 在初始化方法中可以接收一些参数，并进行一些初始化操作
        L.setOptions(this, options);
    },

    // 在 addLayer 方法中定义如何向地图添加图层
    onAdd: function (map) {
        // 在这里可以添加图层到地图上
        // 比如，创建 DOM 元素并将其添加到地图容器中
        this._mapLayer = L.geoJSON(this.options.data, {
            pane: "tradezoneinsights_gridlayer_pane_0",
            style: function (feature) {
                return {
                    color: 'rgba(255,255,255,0.05)',
                    opacity: 1,
                    fillColor: "rgba(255,255,255,0.2)",
                    fillOpacity: 1,
                    weight: 1,
                    radius: 7
                }
            },
            // renderer: L.canvas({ padding: 15 }),
            renderer: L.canvas({ pane: "tradezoneinsights_gridlayer_pane_0" }),
            filter: function (feature) {
                return true
            }
        });
        map.addLayer(this._mapLayer)
    },

    // 在 removeLayer 方法中定义如何从地图移除图层
    onRemove: function (map) {
        console.log(map);
        // 在这里可以移除图层，清理资源等操作
    }
});